var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPbv3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.81 17.2833C22.9234 11.8037 14.6976 11.4716 9.40379 16.37C9.15962 16.6193 8.83393 16.8682 8.58936 17.2002L8.26367 17.7816L8.67089 18.2798L8.75241 18.3625C13.5575 23.7591 21.7833 24.0915 27.0771 19.1927C27.3212 18.9438 27.6469 18.6949 27.8915 18.3625L28.2987 17.7816L27.81 17.2833ZM16.571 17.7816C16.571 16.8682 17.3039 16.1211 18.1999 16.1211C19.0954 16.1211 19.8287 16.8682 19.8287 17.7816C19.8287 18.6949 19.0954 19.442 18.1999 19.442C17.3039 19.442 16.571 18.6949 16.571 17.7816ZM17.1409 14.6264C15.4305 15.2077 14.5349 17.0344 15.0233 18.7776C15.3494 19.7741 16.0823 20.6043 17.1409 20.9363C14.6161 20.6874 12.1728 19.6079 10.2997 17.7816C12.2543 15.9549 14.6161 14.8757 17.1409 14.6264ZM19.2585 20.9363C20.9688 20.3554 21.8648 18.5287 21.3761 16.7851C21.0504 15.7891 20.3171 14.9588 19.2585 14.6264C21.7833 14.8757 24.2266 15.9549 26.0996 17.7816C24.145 19.6079 21.7833 20.6874 19.2585 20.9363Z",
    fill: "url(#paint0_linear_1947_121)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1988 3.66748C10.5429 3.66748 4.35352 9.9774 4.35352 17.7816C4.35352 25.5858 10.5429 31.8957 18.1988 31.8957C25.8544 31.8957 32.0441 25.5858 32.0441 17.7816C32.0441 9.9774 25.8544 3.66748 18.1988 3.66748ZM18.1988 30.2352C11.4388 30.2352 5.98237 24.6724 5.98237 17.7816C5.98237 10.8903 11.4388 5.32796 18.1988 5.32796C24.9584 5.32796 30.4153 10.8903 30.4153 17.7816C30.4153 24.6724 24.9584 30.2352 18.1988 30.2352Z",
    fill: "url(#paint1_linear_1947_121)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8902 36.0472V8.64925C45.8902 6.32433 44.0983 4.49805 41.8181 4.49805H32.8594V6.15853H41.8181C43.2024 6.15853 44.2614 7.23768 44.2614 8.64925V36.0472H45.8902Z",
    fill: "url(#paint2_linear_1947_121)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16895 33.5562V41.8586C5.16895 44.1831 6.96045 46.0098 9.24109 46.0098H37.7461V44.3493H9.24109C7.8564 44.3493 6.7978 43.2697 6.7978 41.8586V33.5562H5.16895Z",
    fill: "url(#paint3_linear_1947_121)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3027 8.64941H42.6326V10.3099H35.3027V8.64941Z",
    fill: "url(#paint4_linear_1947_121)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9316 12.8008H42.6326V14.4613H36.9316V12.8008Z",
    fill: "url(#paint5_linear_1947_121)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9316 16.9517H42.6326V18.6121H36.9316V16.9517Z",
    fill: "url(#paint6_linear_1947_121)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9316 21.1025H42.6326V22.763H36.9316V21.1025Z",
    fill: "url(#paint7_linear_1947_121)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9316 25.2534H42.6326V26.9139H36.9316V25.2534Z",
    fill: "url(#paint8_linear_1947_121)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7461 29.4048H42.6327V31.0653H37.7461V29.4048Z",
    fill: "url(#paint9_linear_1947_121)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 36.8774H30.4163V38.5379H8.42676V36.8774Z",
    fill: "url(#paint10_linear_1947_121)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 40.1978H33.6741V41.8582H8.42676V40.1978Z",
    fill: "url(#paint11_linear_1947_121)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.499 24.4238H23.901V26.0843H12.499V24.4238Z",
    fill: "url(#paint12_linear_1947_121)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.499 9.47949H23.901V11.14H12.499V9.47949Z",
    fill: "url(#paint13_linear_1947_121)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4333 35.1337C39.9445 34.6355 39.3747 34.3866 38.7229 34.3866H38.153L32.289 27.6616C37.6643 19.6912 35.7909 8.81491 27.9727 3.25253C20.1541 -2.31025 9.40345 -0.234642 4.02814 7.65265C-1.34678 15.5399 0.526251 26.4993 8.34485 32.0617C14.5346 36.4622 22.8415 36.2129 28.7871 31.3976L34.4881 37.9565V38.6209C34.4881 39.2849 34.7323 39.949 35.221 40.3641L43.691 48.9989C45.1568 50.4932 47.4375 50.4932 48.9033 48.9989C50.3695 47.5042 50.3695 45.1797 48.9033 43.6851L40.4333 35.1337ZM2.72537 17.7818C2.72537 9.06423 9.64802 2.00717 18.1995 2.00717C26.751 2.00717 33.6737 9.06423 33.6737 17.7818C33.6737 26.4993 26.751 33.5564 18.1995 33.5564C9.64802 33.5564 2.72537 26.4993 2.72537 17.7818ZM30.0088 30.4012C30.416 29.9861 30.9043 29.4882 31.2304 29.0731L36.6053 35.2168L35.3025 36.4622L30.0088 30.4012ZM46.2973 48.5007C45.7271 48.5007 45.2383 48.2514 44.8311 47.9194L36.3611 39.2849C36.1981 39.1187 36.117 38.9529 36.117 38.7036V38.0396L38.0715 36.0471H38.7229C38.9675 36.0471 39.1301 36.1302 39.2932 36.296L47.7631 44.9304C48.5776 45.7607 48.5776 47.0891 47.7631 47.9194C47.3559 48.2514 46.7857 48.5007 46.2973 48.5007Z",
    fill: "url(#paint14_linear_1947_121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1947_121",
    x1: 18.2812,
    y1: 12.9209,
    x2: 18.2812,
    y2: 22.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1947_121",
    x1: 18.1988,
    y1: 3.66748,
    x2: 18.1988,
    y2: 31.8957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1947_121",
    x1: 39.3748,
    y1: 4.49805,
    x2: 39.3748,
    y2: 36.0472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1947_121",
    x1: 21.4575,
    y1: 33.5562,
    x2: 21.4575,
    y2: 46.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1947_121",
    x1: 38.9677,
    y1: 8.64941,
    x2: 38.9677,
    y2: 10.3099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1947_121",
    x1: 39.7821,
    y1: 12.8008,
    x2: 39.7821,
    y2: 14.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1947_121",
    x1: 39.7821,
    y1: 16.9517,
    x2: 39.7821,
    y2: 18.6121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1947_121",
    x1: 39.7821,
    y1: 21.1025,
    x2: 39.7821,
    y2: 22.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1947_121",
    x1: 39.7821,
    y1: 25.2534,
    x2: 39.7821,
    y2: 26.9139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1947_121",
    x1: 40.1894,
    y1: 29.4048,
    x2: 40.1894,
    y2: 31.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1947_121",
    x1: 19.4216,
    y1: 36.8774,
    x2: 19.4216,
    y2: 38.5379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1947_121",
    x1: 21.0504,
    y1: 40.1978,
    x2: 21.0504,
    y2: 41.8582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1947_121",
    x1: 18.2,
    y1: 24.4238,
    x2: 18.2,
    y2: 26.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1947_121",
    x1: 18.2,
    y1: 9.47949,
    x2: 18.2,
    y2: 11.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1947_121",
    x1: 25.4858,
    y1: 0.119629,
    x2: 25.4858,
    y2: 50.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbv3);
export default __webpack_public_path__ + "static/media/Pbv3.5bef1080bb5975e9687856ae239f87aa.svg";
export { ForwardRef as ReactComponent };